import TreeDiagramRenderer from './tree-renderer.view';
import TreeDiagram from './tree-diagram.view';

export function treeDiagramRendererFactory() {
	return {
    getInstance: function (questions, zoom, scheme, mouseWheelZoom) {
      return new TreeDiagramRenderer(questions, scheme, zoom, mouseWheelZoom);
    }
  };
}

export function treeDiagramFactory($timeout, audioService) {
	"ngInject";
	return {
    getInstance: function(exercise, renderer) {
      return new TreeDiagram(exercise, renderer, $timeout, audioService);
    }
  };
}



// WEBPACK FOOTER //
// ./client/app/components/tree-diagram/factory.js